import { Switch, SwitchProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormSwitchProps<Values = Record<string, unknown>>
  extends SwitchProps,
    IFocusableFormField<Values> {}

export const FormSwitch: <Values = Record<string, unknown>>(
  props: IFormSwitchProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, readOnly, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  if (readOnly) {
    rest.onChange = () => {};
    rest.color = "gray";
  }
  return (
    <Switch
      {...parentForm.getInputProps(fieldName, { type: "checkbox" })}
      {...rest}
      ref={elementRef}
    />
  );
};
